const odProductDrawer = document.getElementById('product-drawer');
const odDrawerOpenerList = document.querySelectorAll('.product_drawer_opener__button');
let isManualSwitch = false;

if (odProductDrawer) {
    const contentContainer = odProductDrawer.querySelector(".content-drawer__content");
    const blocks = [...odProductDrawer.querySelectorAll(".content__block")];

    const getVisibleArea = (element) => {
        const rect = element.getBoundingClientRect();
        const containerRect = contentContainer.getBoundingClientRect();
        const visibleHeight = Math.min(rect.bottom, containerRect.bottom) - Math.max(rect.top, containerRect.top);
        return visibleHeight > 0 ? visibleHeight : 0;
    };

    const updateActiveBlock = () => {
        if (isManualSwitch) return;

        let maxArea = 0;
        let activeBlock = null;
        let centeredBlock = null;
        let centerOffset = Infinity;

        const containerCenter = contentContainer.getBoundingClientRect().top + contentContainer.clientHeight / 2;

        blocks.forEach((block) => {
            const area = getVisibleArea(block);
            if (area > maxArea) {
                maxArea = area;
                activeBlock = block;
            }

            const rect = block.getBoundingClientRect();
            const blockCenter = rect.top + rect.height / 2;
            const offset = Math.abs(containerCenter - blockCenter);
            if (offset < centerOffset) {
                centerOffset = offset;
                centeredBlock = block;
            }
        });

        if (centeredBlock) {
            updateActiveLink(centeredBlock.id);
        }
    };

    const updateActiveLink = (id) => {
        odProductDrawer.querySelectorAll(".element--anchor").forEach((link) => link.classList.remove("active"));
        const activeLink = odProductDrawer.querySelector(`.element--anchor[href="#${id}"]`);
        if (activeLink) {
            activeLink.classList.add("active");
        }
    };

    contentContainer.scrollTop = 0;

    contentContainer.addEventListener("scroll", () => {
        if (isManualSwitch) return;

        const scrollTop = contentContainer.scrollTop;
        const scrollHeight = contentContainer.scrollHeight - contentContainer.clientHeight;

        if (scrollTop === 0) {
            updateActiveLink(blocks[0].id);
        } else if (scrollTop >= scrollHeight) {
            updateActiveLink(blocks[blocks.length - 1].id);
        } else {
            updateActiveBlock();
        }
    });

    odProductDrawer.querySelectorAll(".element--anchor").forEach((link) => {
        link.addEventListener("click", (event) => {
            event.preventDefault();
            const targetId = link.getAttribute("href").substring(1);
            const targetBlock = document.getElementById(targetId);
            if (targetBlock) {
                isManualSwitch = true;
                targetBlock.scrollIntoView({ behavior: "smooth", block: "start" });
                updateActiveLink(targetId);
                setTimeout(() => { isManualSwitch = false; }, 1000);
            }
        });
    });

    const targetNode = odProductDrawer.querySelector('.drawer-review__content');
    if (targetNode) {
        const observer = new MutationObserver((mutationsList) => {
            for (let mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    const stampedContainer = targetNode.querySelector('.stamped-container');
                    if (stampedContainer) {
                        const stampedSummary = stampedContainer.querySelector('.stamped-summary-text');
                        if (stampedSummary) {
                            const dataCount = stampedSummary.getAttribute('data-count');
                            odProductDrawer.querySelectorAll('.review-handle .count').forEach((handle) => {
                                handle.textContent = `${handle.textContent} (${dataCount})`;
                            });
                            observer.disconnect();
                            break;
                        }
                    }
                }
            }
        });
        observer.observe(targetNode, { childList: true, subtree: true });
    }

    odProductDrawer.addEventListener("click", (event) => {
        if (!event.target.closest(".product-drawer__content-wrapper") || event.target.closest(".od-icon-button")) {
            odProductDrawer.classList.remove("open");
        }
    });

    odDrawerOpenerList.forEach((opener) => {
        opener.addEventListener("click", () => {
            odProductDrawer.classList.add("open");
        });
    });

    odProductDrawer.querySelectorAll(".block__title").forEach((element) => {
        element.addEventListener("click", (event) => {
            const block = event.target.closest(".content__block");
            if (block) {
                const isOpen = block.classList.contains("open");
                blocks.forEach((el) => el.classList.remove("open"));
                if (!isOpen) block.classList.add("open");
            }
        });
    });

    window.addEventListener("hashchange", () => {
        const hash = window.location.hash.substring(1);
        if (hash) {
            updateActiveLink(hash);
        }
    });

    if (window.location.hash) {
        updateActiveLink(window.location.hash.substring(1));
    }

    setTimeout(() => {
        updateActiveLink(blocks[0].id);
    }, 50);


    const infoWrapper = document.querySelector('.product__info-wrapper');

    if (infoWrapper) {
        const observerInfo = new MutationObserver((mutations, obs) => {
            const badge = infoWrapper.querySelector('.stamped-product-reviews-badge');
            if (badge) {
                badge.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    
                    odProductDrawer.querySelector('.review-handle')?.click();
                    odProductDrawer.querySelector('.review__block')?.classList.add('open');
                    setTimeout(() => {
                        odProductDrawer.classList.add("open");
                    }, 1000);
                }, true);

                obs.disconnect();
            }
        });

        observerInfo.observe(infoWrapper, {
            childList: true,
            subtree: true,
        });
    }
}
